import { Reducer } from 'redux';
import { IUser, IUserAccess } from './models';
import { getTokenData } from '../helpers/decodeToken';
import { SessionStorageService } from 'services/sessionStorageService';
import { SawmillUserInfoResponse } from '.generated/api';

export interface LoginState {
  isLoggedIn: boolean;
  user?: IUser;
  userAccess?: IUserAccess;
  error?: string;
  sawmillUserInfo?: SawmillUserInfoResponse;
}
export interface LogInAction {
  type: 'LOGIN_SUCCESS';
  user: IUser;
}
export interface LogInFailure {
  type: 'LOGIN_FAILURE';
  username: string;
}
export interface LogOutAction {
  type: 'LOGOUT';
}

export interface SetUserInfoAction {
  type: 'SET_USER_INFO';
  userInfo: IUserAccess;
}

export interface SetSawmillUserInfoAction {
  type: 'SET_SAWMILL_USER_INFO';
  userInfo: SawmillUserInfoResponse;
}

type LogInActionTypes =
  | LogInAction
  | LogInFailure
  | LogOutAction
  | SetUserInfoAction
  | SetSawmillUserInfoAction;

const loginReducer: Reducer<LoginState> = (
  state: LoginState | undefined,
  incomingAction: LogInActionTypes,
): LoginState => {
  if (state === undefined) {
    const token = SessionStorageService.getToken();
    if (token) {
      const tokenData = getTokenData(token);
      const user: IUser = {
        username: tokenData.username,
        password: '',
      };

      return {
        isLoggedIn: true,
        user: user,
      };
    } else {
      return { isLoggedIn: false };
    }
  }

  const action = incomingAction;

  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return { ...state, isLoggedIn: true, user: action.user };
    case 'LOGIN_FAILURE':
      return { isLoggedIn: false, error: action.username };
    case 'LOGOUT':
      return { isLoggedIn: false };
    case 'SET_USER_INFO': {
      return {
        isLoggedIn: state.isLoggedIn,
        user: state.user,
        error: state.error,
        userAccess: {
          isGlobalAdmin: action.userInfo.isGlobalAdmin,
          departments: action.userInfo.departments,
          organizations: action.userInfo.organizations,
          sawmills: action.userInfo.sawmills,
        },
      };
    }
    case 'SET_SAWMILL_USER_INFO':
      return { ...state, sawmillUserInfo: action.userInfo };
    default:
      return state;
  }
};

export { loginReducer };
